import type { Snippet } from 'svelte';
import type { Action } from 'svelte/action';
import { type Spacing, type ResponseSpacing } from '@athena-lib/spacing';
import type { DeviceName } from '@athena-lib/device';

export const gridContextKey = Symbol('athena-grid-context');

export type { Spacing, ResponseSpacing };

// 5 is intentionally left out because it's not possible to fit into a 12 grid system
export type GridColumns = 1 | 2 | 3 | 4 | 6 | 12;
export type ResponsiveGridColumns = Partial<Record<DeviceName, GridColumns>>;

export type GridColumnSpan = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type ResponsiveGridColumnSpan = Partial<Record<DeviceName, GridColumnSpan>>;

export type GridRowSpan = 1 | 2 | 3 | 4 | 5 | 6;
export type ResponsiveGridRowSpan = Partial<Record<DeviceName, GridRowSpan>>;

export type GridContext = {
  space: () => Spacing | ResponseSpacing;
  columns: () => GridColumns | ResponsiveGridColumns | undefined;
  renderedItems: number;
};

export type GridProps = {
  class?: string;
  space?: Spacing | ResponseSpacing;
  columns?: GridColumns | ResponsiveGridColumns;
  children: Snippet;
  action?: Action<HTMLDivElement, NonNullable<unknown>>;
  actionArg?: NonNullable<unknown>;
};

export type GridItemProps = {
  class?: string;
  children: Snippet;
  action?: Action<HTMLDivElement, NonNullable<unknown>>;
  actionArg?: NonNullable<unknown>;
  colSpan?: GridColumnSpan | ResponsiveGridColumnSpan;
  rowSpan?: GridRowSpan | ResponsiveGridRowSpan;
};
